import * as React from "react"
import { cn } from '@/utils/index'
import { PaginationLink } from "./pagination-link"
import { ArrowLeftCircle } from "lucide-react"

export const PaginationPrevious = React.forwardRef<HTMLAnchorElement, React.ComponentProps<typeof PaginationLink>>(
  ({ className, disabled, ...props }, ref) => (
    <PaginationLink
      ref={ref}
      aria-label="Go to previous page"
      size="lg"
      className={cn(
        "flex size-8 items-center justify-center border-0 px-0 py-0 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      disabled={disabled}
      {...props}
    >
      <ArrowLeftCircle size={50} />
    </PaginationLink>
  )
)
PaginationPrevious.displayName = "PaginationPrevious"
